<template>
  <div
    :style="{ width }"
    class="snt-tag-suggestions">
    <v-autocomplete
      :value="value"
      :items="allItems"
      :search-input.sync="searchText"
      :label="label"
      :menu-props="{
        nudgeTop: '-4',
        contentClass:'snt-tag-suggestions__content'
      }"
      :append-icon="''"
      :hide-details="hideDetails"
      :item-text="itemValue"
      :item-value="itemValue"
      :placeholder="placeholder"
      :readonly="readonly"
      multiple
      hide-selected
      hide-no-data
      outlined
      dense
      chips
      solo
      flat
      v-on="$listeners"
      @keydown.enter="add($event)">
      <template #selection="{ attrs, select, item, index }">
        <snt-chip
          v-bind="attrs"
          class="ma-1"
          label
          small
          close
          @click="select"
          @click:close="remove(index)">
          {{ getValue(item) }}
        </snt-chip>
      </template>
      <template #item="{ attrs, item }">
        <snt-chip
          v-bind="attrs"
          class="cs-pointer"
          label
          small>
          {{ getValue(item) }}
        </snt-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { getPropertyFromItem } from 'vuetify/lib/util/helpers'

export default {
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    items: {
      type: Array,
      default: () => ([])
    },
    label: {
      type: String,
      default: undefined
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    placeholder: {
      type: String,
      default: undefined
    },
    readonly: Boolean,
    hideDetails: Boolean
  },
  data () {
    return {
      searchText: ''
    }
  },
  computed: {
    allItems () {
      const headers = [{ header: 'คำแนะนำ:' }]
      const newItems = this.value.map((tag) => ({ [this.itemValue]: tag }))
      const allItems = this.$_.concat(this.items, newItems)
      return this.$_.uniqBy(this.$_.concat(headers, allItems), this.itemValue)
    }
  },
  methods: {
    getValue (item) {
      return getPropertyFromItem(item, this.itemValue, item)
    },
    add (e) {
      const values = this.$_.cloneDeep(this.value)
      const value = e.target.value
      if (!values.includes(value)) {
        values.push(value)
        this.$emit('input', values)
      }
      this.searchText = ''
    },
    remove (index) {
      const values = this.$_.cloneDeep(this.value)
      values.splice(index, 1)
      this.$emit('input', values)
    }
  }

}
</script>

<style lang="scss" scoped>
  .snt-chip {
    height: 100%;
    ::v-deep {
      .v-chip__content {
        cursor: pointer;
        word-break: break-word;
        white-space: pre-line;
        width: max-content;
        background-color: var(--v-select-base) !important;
      }
    }
  }
  .snt-tag-suggestions {
    &__content {
      .v-select-list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding: 8px;
        max-width: fit-content;
        min-width: 100%;
        border: 1px solid var(--v-primary-base);
        border-radius: 4px;
        ::v-deep {
          .v-subheader {
            color: var(--v-field-grey-base);
            font-size: 12px;
            padding: 0;
            width: 100%;
            min-height: 24px;
            height: 100%;
          }
          .v-list-item {
            flex: 0;
            padding: 0;
            min-height: 24px;
            height: 100%;
          }
        }
      }
    }
  }
</style>
